import { APIResponseType } from 'app/apiService/types';
import apiService from '..';

export interface ManufacturerMake {
  make_id: string;
  make_name: string;
  _id: string;
}

export interface ManufacturerDetail {
  _id: string;
  _v: number;
  man_id: string;
  man_name: string;
  make: ManufacturerMake[];
}

export interface ManufacturersResponse {
  body: {
    carlistDetails: ManufacturerDetail[];
  };
  message: string;
}

class Manufacturers {
  static ENDPOINT = 'api/v1/admin/manufacturers/newmanufacturers';

  static async getAllManufacturers(params?: any): Promise<APIResponseType<ManufacturersResponse>> {
    try {
      const response = await apiService.get<APIResponseType<ManufacturersResponse>>(this.ENDPOINT, params);
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default Manufacturers;

